<template>
    <div
        ref="editorElement"
        class="json-editor"
        @keydown.stop
        @keyup.stop
        @keypress.stop
    ></div>
</template>

<script>
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import * as monaco from "monaco-editor/editor/editor.api.js";

export default {
    name: "JsonEditor",
    props: {
        modelValue: {
            type: String,
            default: "",
        },
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
        const editorElement = ref(null);
        let editorInstance = null;
        let changeListener = null;

        onMounted(() => {
            editorInstance = monaco.editor.create(editorElement.value, {
                value: props.modelValue,
                language: "json",
                theme: "vs",
                automaticLayout: true,
                lineNumbers: "on",
                minimap: {
                    enabled: false,
                },
                scrollBeyondLastLine: false,
                formatOnPaste: true,
                formatOnType: true,
            });

            changeListener = editorInstance.onDidChangeModelContent(() => {
                emit("update:modelValue", editorInstance.getValue());
            });
        });

        watch(
            () => props.modelValue,
            (newValue) => {
                if (editorInstance && newValue !== editorInstance.getValue()) {
                    editorInstance.setValue(newValue ?? "");
                }
            },
        );

        onBeforeUnmount(() => {
            changeListener?.dispose();
            editorInstance?.dispose();
        });

        return {
            editorElement,
        };
    },
};
</script>

<style scoped>
.json-editor {
    height: 200px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding-top: 12px;
    padding-bottom: 12px;
}
</style>
